var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefinance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)",
    stroke: "#0B966B",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.167,
    cy: 15.625,
    rx: 2.533,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19.375c4.897 0 8.867-3.918 8.867-8.75s-3.97-8.75-8.867-8.75c-3.339 0-6.115 2.051-7.6 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9.625v6.25h6.333"
  }))));
}
export default SvgIconRefinance;